import { useEffect, useState } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from 'src/queryClient';
import { useKeyPress } from 'src/utils/useKeyPress';

import { useFeatureFlags } from 'src/utils/useFeatureFlags';
import type { ApiProviderProps } from './endpoints/storeApi.types';

export const ApiProvider = ({
  withDevtools = false,
  children,
}: ApiProviderProps) => {
  const pressedKeyCombo = useKeyPress('•'); // alt + q
  const [showDevtools, setShowDevtools] = useState(false);
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    if (featureFlags.EnableReactQueryDevtools && pressedKeyCombo) {
      setShowDevtools(!showDevtools);
    }
  }, [pressedKeyCombo]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevtools && withDevtools && (
        <div className="absolute">
          <ReactQueryDevtools initialIsOpen={true} />
        </div>
      )}
    </QueryClientProvider>
  );
};
